import { forwardRef } from 'react';
import styled from 'styled-components';
import { devices } from 'signup-constants/styles/viewports.styles';
import { DisplayMode } from '../views-components/DisplayMode';
import TextInput from '../views-components/TextInput';
import { useInputProps } from './useInputProps';
import { useSignupData } from './useSignupData';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { LayoutType } from 'signup-components/types';
import { Step } from 'signup-constants/Step';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { isLeftAlignedLayout } from '../utils/isLeftAlignedLayout';
import SignupFormControl from '../views-components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDataInput = styled.div.withConfig({
  displayName: "SignupDataInput__StyledDataInput"
})(["min-height:6.5rem;label{font-weight:", ";font-size:", ";}@media ", "{min-height:6.5rem;", "}", " ", ""], ({
  theme
}) => theme.typography['body-300'].fontWeight, ({
  theme
}) => theme.typography['body-200'].fontSize, devices.desktop, props => isLeftAlignedLayout(props.$layoutType) && props.$currentStep !== Step.LandingPage && `width: 420px;`, props => props.theme.embedded && `min-height: 4.7rem;`, props => props.height && `min-height: ${props.height} !important;`);
export const SignupDataInput = /*#__PURE__*/forwardRef(({
  dataKey,
  disabled = false,
  displayMode = DisplayMode.Placeholder,
  customValidationError,
  renderExtraIcons,
  type,
  inputMode,
  autoFocus = true,
  help,
  shouldShowPlaceholder = false,
  onFocus,
  onBlur,
  shouldTrimData = false,
  height = '',
  labelOverride,
  formControlMaxInlineSize,
  updateInputStyle = false
}, ref) => {
  const {
    data,
    setData
  } = useSignupData(dataKey, shouldTrimData);
  const inputProps = useInputProps(dataKey);
  const {
    layoutType
  } = useLayoutTemplate();
  const {
    currentStep
  } = useCurrentStep();
  const placeholder = shouldShowPlaceholder ? inputProps.placeholder : '';
  const renderInput = () => {
    return /*#__PURE__*/_jsx(TextInput, Object.assign({
      autoFocus: autoFocus,
      "data-test-id": dataKey,
      disabled: disabled,
      displayMode: displayMode,
      inputMode: inputMode,
      ref: ref,
      renderExtraIcons: renderExtraIcons,
      type: type,
      value: disabled ? '' : data,
      onBlur: onBlur,
      onChange: setData,
      onFocus: onFocus
    }, inputProps, {
      placeholder: placeholder,
      updateInputStyle: updateInputStyle
    }));
  };
  const maybeWrapTextInput = () => {
    return /*#__PURE__*/_jsx(SignupFormControl, {
      customValidationError: customValidationError,
      dataKey: dataKey,
      help: help,
      labelOverride: labelOverride,
      maxInlineSize: formControlMaxInlineSize,
      updateInputStyle: updateInputStyle,
      children: renderInput()
    });
  };
  if (layoutType === LayoutType.SidePanel || updateInputStyle) {
    return maybeWrapTextInput();
  }
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx(StyledDataInput
    // @ts-expect-error Expression produces a union type that is too complex to represent.
    , {
      $currentStep: currentStep,
      $layoutType: layoutType,
      className: `SignupDataInput displayMode-${displayMode}`,
      "data-data-key": dataKey,
      height: height,
      children: maybeWrapTextInput()
    })
  );
});